// extracted by mini-css-extract-plugin
export default {"row":"IntegrationInfo_row__0nUuc"};